import {
  autoUpdate,
  offset,
  shift,
  useClick,
  useDismiss,
  useFloating,
  useInteractions,
} from '@floating-ui/react';
import { useState } from 'react';

export default function useFloatingMenu() {
  const [isOpen, setIsOpen] = useState(false);
  const { refs, context, floatingStyles } = useFloating({
    open: isOpen,
    placement: 'bottom-end',
    onOpenChange: setIsOpen,
    whileElementsMounted: autoUpdate,
    middleware: [shift(), offset(12)],
  });

  const dismiss = useDismiss(context);
  const click = useClick(context);

  const { getFloatingProps, getReferenceProps } = useInteractions([
    dismiss,
    click,
  ]);

  return {
    isOpen,
    refs,
    floatingStyles,
    getFloatingProps,
    getReferenceProps,
  };
}
